/*
 *  Author: DL
 *  Date: 2020-12-03 11:55:36
 *  Email: dunaliang@fengmap.com
 *  LastEditTime: 2020-12-18 12:17:30
 *  LastEditors: DL
 *  Description:
 *  Copyright: Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.
 */

import React from 'react';
import styles from './index.less';
import settingConfig from 'config/setting';

const fengmap = window.fengmap;

const {
    pickFilter: { typeID = [] },
} = settingConfig;

class Fmap extends React.Component {
    constructor(props) {
        super(props);

        this.map = null;
        this.loadCompleteStatus = false;
        this.searchAnalyser = null;
        this.navigation = null;
        this.locationMarker = null;
        this.naviLocationMarker = null;
        this.positionMarker = null;
    }

    componentDidMount() {
        this.initMap();
    }

    initMap() {
        const { mapOptions, mapId } = this.props;

        const map = new fengmap.FMMap({
            ...mapOptions,
            container: document.getElementById('fengMap'),
        });

        map.openMapById(mapId, error => {
            console.log(error);
        });

        map.on('loadComplete', event => {
            this.searchAnalyser = new fengmap.FMSearchAnalyser(map);

            this.navigation = new fengmap.FMNavigation({
                //地图对象
                map: map,
                //模拟导航定位图标行进的速度，单位m/s。默认5m/s。
                speed: 3,
                //导航结果文字描述内容的语言类型参数, 目前支持中英文。参考FMLanguaeType。
                naviLanguage: fengmap.FMLanguageType.ZH,
                //导航中路径规划模式, 支持最短路径、最优路径两种。默认为MODULE_SHORTEST, 最短路径。
                naviMode: fengmap.FMNaviMode.MODULE_SHORTEST,
                //导航中的路线规划梯类优先级, 默认为PRIORITY_DEFAULT, 详情参考FMNaviPriority。
                naviPriority: fengmap.FMNaviPriority.PRIORITY_DEFAULT,
                //设置起点或终点, 是否自动进行路径规划计算。默认为true
                //autoRoute: false,
                //起终点图片标注的与楼层之间的高度偏移设置。默认是6。
                imageMarkerHeight: 6,
                //导航图标
                locationMarkerUrl: './images/location.png',
                //设置Marker尺寸
                locationMarkerSize: 32,
                //模拟导航时是否地图跟随,默认true
                followPosition: true,
                //模拟导航时是否改变地图角度，默认false
                followAngle: true,
                //是否在导航开始时改变地图的倾斜角度,默认为true
                changeTiltAngle: true,
                //导航跟随倾斜角度
                tiltAngle: 80,
                //模拟导航开始时地图的显示比例尺, 默认值为282,表示1:282的地图比例尺。对应比例尺级别21。
                scale: 282,
                //导航线与楼层之间的高度偏移设置。默认是1。
                lineMarkerHeight: 1,
                // 设置导航线的样式
                lineStyle: {
                    // 导航线样式
                    lineType: fengmap.FMLineType.FMARROW,
                    // 设置线的宽度
                    lineWidth: 6,
                },
                passed: false,
            });

            this.navigation.naviToDoor = true;

            map.pickFilterFunction = function (event) {
                //如设置点击墙模型时不高亮

                if (event.nodeType !== fengmap.FMNodeType.MODEL) {
                    return false;
                }

                // 没有名称不允许点击
                if (!event.data.name) {
                    return false;
                }

                if (event.nodeType === fengmap.FMNodeType.MODEL && typeID.includes(event.typeID)) {
                    return false;
                }
                return true;
            };

            this.loadCompleteStatus = true;
        });

        map.on('mapClickNode', event => {
            console.log(event);
        });

        window.map = map;

        this.map = map;
    }

    /**
     * 切换楼层
     * @param {*Number} gid
     */
    changeFloor(gid) {
        if (this.map.visibleGroupIDs.length === 1) {
            this.map.visibleGroupIDs = [gid];
        }
        this.map.focusGroupID = gid;
    }

    /**
     * 地图缩小/放大
     * @param {String} type
     */
    changeZoom(type) {
        const fn = this.map[`${type}`];
        if (fn && typeof fn === 'function') {
            fn.call(this.map);
        }
    }

    /**
     * 2D/3D模式
     * @param {String} viewMode
     */
    changeViewMode(viewMode) {
        this.map.viewMode = viewMode;
    }

    /**
     * 单/多楼层切换
     * @param {String} layerMode  single/multi
     */
    changeLaryerMode(layerMode) {
        let visibleGroups = [this.map.focusGroupID];

        if (layerMode === 'multi') {
            visibleGroups = this.map.groupIDs;
        }

        this.map.visibleGroupIDs = visibleGroups;
    }

    /**
     * 添加imageMarker
     * @param {Object} data
     */
    addImageMarker(data) {
        const { groupID, ...marker } = data;

        const group = this.map.getFMGroup(groupID);
        const layer = group.getOrCreateLayer('imageMarker');

        //图标标注对象，默认位置为该楼层中心点
        // var gpos = group.mapCoord;
        const im = new fengmap.FMImageMarker({
            ...marker,
            //标注x坐标点
            // x: gpos.x,
            //标注y坐标点
            // y: gpos.y,
            //设置图片路径
            url: './images/marker.png',
            size: 32,
            height: 4,
        });

        /**
         * imageMarker添加自定义属性
         **/
        // im.selfAttr = '';

        layer.addMarker(im);
        return im;
    }

    /**
     * 根据groupID获取Floor
     * @param {Number} groupID
     */
    getFloorBygroupID(groupID) {
        const listGroups = this.map.listGroups;
        return listGroups.filter(({ gid }) => gid === groupID)[0].gname.toUpperCase();
    }

    /**
     * 搜索地图
     * @param {Array} options
     */
    mapSearchByParams(options) {
        let searchRequest = new fengmap.FMSearchRequest();

        options.forEach(({ key, value }) => {
            searchRequest[key] = value;
        });

        return this.searchAnalyser.getQueryResult(searchRequest, ['SINGLE']).map(item => {
            const {
                FID,
                name,
                groupID,
                mapCoord: { x, y },
            } = item;

            return { FID, name: name ? name.replace(/\%rn\%/g, '') : '', groupID, x, y, floor: this.getFloorBygroupID(groupID) };
        });
    }

    getMapCoordToCenter(FID) {
        let coord = null;

        const label = this.mapSearchByParams([
            { key: 'FID', value: FID },
            { key: 'nodeType', value: fengmap.FMNodeType.LABEL },
        ]);

        if (label.length === 0) {
            const modal = this.mapSearchByParams([
                { key: 'FID', value: FID },
                { key: 'nodeType', value: fengmap.FMNodeType.MODEL },
            ]);

            coord = modal.length > 0 ? modal[0] : null;
        } else {
            coord = label[0];
        }

        return coord;
    }

    /**
     * 模拟导航
     * @param {Object} coords
     */
    createNaviSimulate(coords) {
        if (!this.navigation) return;

        this.navigation.clearAll();

        const { start, end } = coords;

        //添加起点
        this.navigation.setStartPoint({
            x: start.x,
            y: start.y,
            groupID: start.groupID,
            url: './images/start.png',
            size: 32,
        });

        //添加终点
        this.navigation.setEndPoint({
            x: end.x,
            y: end.y,
            groupID: end.groupID,
            url: './images/end.png',
            size: 32,
        });

        // 画出导航线
        this.navigation.drawNaviLine()
    }

    /**
     * 更新positionMarker位置
     * @param {Object} param
     */
    updatePositionMarker({ x, y, groupID }) {
        if (this.positionMarker) {
            if (this.positionMarker.show === false) {
                this.positionMarker.show = true;
            }
            this.positionMarker.setPosition(x, y, groupID, 0);
        } else {
            const group = this.map.getFMGroup(groupID);
            const layer = group.getOrCreateLayer('imageMarker');

            const positionMarker = new fengmap.FMImageMarker({
                x,
                y,
                url: './images/marker.png',
                size: 32,
                height: 0,
            });

            this.positionMarker = positionMarker;
            layer.addMarker(positionMarker);
        }
    }

    visibleUpdatePositionMarke(visible) {
        if (this.positionMarker) {
            this.positionMarker.show = visible;
        }
    }

    /**
     * 更新locationMarker位置
     * @param {Object} param
     */
    updateLocationMarker(coord) {
        // const { x, y, groupID } = coord;
        const {
            coord: { x, y, groupID },
        } = this.navigation.pathConstraint(coord);

        if (x === undefined && y === undefined) {
            return;
        }

        if (this.locationMarker) {
            if (this.locationMarker.groupID !== groupID) {
                this.locationMarker.setPosition({ x, y, groupID });
            } else {
                this.locationMarker.moveTo({ x, y });
            }
        } else {
            const locationMarker = new fengmap.FMLocationMarker({
                x,
                y,
                groupID,
                url: './images/location.png',
                height: 3,
                size: 32,
                callback: function () { },
            });
            this.map.addLocationMarker(locationMarker);
            this.locationMarker = locationMarker;
        }
    }

    updateNaviLocationMarker(coord) {
        const {
            coord: { x, y, groupID },
        } = this.navigation.pathConstraint(coord);

        if (this.naviLocationMarker) {
            if (this.naviLocationMarker.groupID !== groupID) {
                this.naviLocationMarker.setPosition({ x, y, groupID });
            } else {
                this.naviLocationMarker.moveTo({ x, y });
            }
        } else {
            const locationMarker = new fengmap.FMLocationMarker({
                x,
                y,
                groupID,
                url: './images/location.png',
                height: 3,
                size: 32,
                callback: function () { },
            });
            locationMarker.avoid(false);
            this.map.addLocationMarker(locationMarker);
            this.naviLocationMarker = locationMarker;
        }
    }

    visibleUpdateNaviLocationMarker(visible) {
        if (this.naviLocationMarker) {
            this.naviLocationMarker.show = visible;
        }
    }

    removeUpdateNaviLocationMarker() {
        if (this.naviLocationMarker) this.map.removeLocationMarker(this.naviLocationMarker);
    }

    /**
     * 显示隐藏locationMarker
     * @param {Boolean} visible
     */
    visibleLocationMarker(visible) {
        if (this.locationMarker) {
            this.locationMarker.show = visible;
        }
    }
    render() {
        return <div className={styles.fmap} id="fengMap"></div>;
    }
}

export default Fmap;
